export default __webpack_public_path__ + "static/media/Projects.4c019d9b.PNG";